import service from "@/api/request";
export const getExamList = (params) => service.getByParams('/courseAdmin/exam/page', params);
export const getExamDetail = (id) => service.getByParams('/courseAdmin/exam/get', { id });
export const requestExamStatusChange = (id, examStatus) => service.postByForm('/courseAdmin/exam/changeStatus', { id, examStatus });
export const getAppraiseList = (params) => service.getByParams('/courseAdmin/exam/comment/page', params);
export const saveExamDetail = (data) => service.postByJson('/courseAdmin/exam/saveOrUpdate', data);
export const getAppraiseDetail = (params) => service.getByParams('/courseAdmin/exam/comment/get', params);
